import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import ServicesRailContainer from '../components/services-rail-container'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Lustrous Narrow Barracuda</title>
        <meta property="og:title" content="Lustrous Narrow Barracuda" />
        <link
          rel="canonical"
          href="https://lustrous-narrow-barracuda-lz4uy2.teleporthq.app/"
        />
        <meta
          property="og:url"
          content="https://lustrous-narrow-barracuda-lz4uy2.teleporthq.app/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-media-container">
          <video
            src="https://videos.pexels.com/video-files/4169772/4169772-hd_1920_1080_25fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/4169772/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-video"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="hero-text-block">
            <span className="hero-tagline home-thq-hero-tagline-elm">
              Dallas–Fort Worth Metroplex • Statewide • Nationwide
            </span>
            <h1 className="home-hero-title hero-title">
              KS Process Service, Inc.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </h1>
            <h2 className="home-hero-title home-thq-hero-title2-elm">
              <span>Providing Professional Process Service   </span>
              <br></br>
              <br></br>
            </h2>
            <a href="tel:214-355-0875">
              <p className="home-thq-hero-subtitle-elm home-hero-subtitle hero-subtitle">
                <span>Kurt Schedler, President</span>
                <br></br>
                <span>(214) 355-0875</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </a>
            <div className="hero-cta-group">
              <a href="tel:2143550875">
                <div className="home-thq-btn-elm1 btn btn-lg btn-primary">
                  <span>Call Us</span>
                </div>
              </a>
              <a href="mailto:ksprocess@verizon.net?subject=Service Request">
                <div className="home-thq-btn-elm2 btn btn-outline btn-lg">
                  <span>Email Us</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section id="services" className="services-section">
        <div className="services-header">
          <h2 className="section-title">Our Legal Support Services</h2>
          <p className="section-subtitle">
            Comprehensive solutions for all your process service needs
          </p>
        </div>
        <ServicesRailContainer
          sectionContent={
            <Fragment>
              <span className="home-text19">
                Immediate dispatch for time-sensitive legal documents across the
                DFW Metroplex.
              </span>
            </Fragment>
          }
          sectionContent1={
            <Fragment>
              <span className="home-text20">
                Expert process service covering every corner of the Dallas–Fort
                Worth area.
              </span>
            </Fragment>
          }
          sectionContent3={
            <Fragment>
              <span className="home-text21">
                Coordinated service across the United States via a professional
                network of certified servers.
              </span>
            </Fragment>
          }
          sectionContent4={
            <Fragment>
              <span className="home-text22">
                Convenient mobile notary services for all notary needs.
              </span>
            </Fragment>
          }
          serviceCardTitle={
            <Fragment>
              <span className="home-text23">
                <span>
                  Rush
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>Service</span>
                <br></br>
              </span>
            </Fragment>
          }
          serviceCardTitle1={
            <Fragment>
              <span className="home-text28">DFW Metroplex Coverage</span>
            </Fragment>
          }
          serviceCardTitle3={
            <Fragment>
              <span className="home-text29">Nationwide Network</span>
            </Fragment>
          }
          serviceCardTitle4={
            <Fragment>
              <span className="home-text30">Mobile Notary Services</span>
            </Fragment>
          }
          servicesRailContainerId="ServicesRailContainer"
        ></ServicesRailContainer>
      </section>
      <section className="stats-section">
        <div className="stats-container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle r="4" cx="12" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <div className="stat-number">
                <span>Kurt Schedler</span>
              </div>
              <div className="stat-label">
                <span>President &amp; CEO</span>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="stat-number">
                <span>TPSA Member</span>
              </div>
              <div className="stat-label">
                <span>Texas Process Server Association</span>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11l3 3L22 4"></path>
                  </g>
                </svg>
              </div>
              <div className="stat-number">
                <span>50k+</span>
              </div>
              <div className="stat-label">
                <span>Successful Serves</span>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="stat-number">
                <span>30+</span>
              </div>
              <div className="stat-label">
                <span>Years of Experience</span>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="5"
                      y="2"
                      rx="2"
                      ry="2"
                      width="14"
                      height="20"
                    ></rect>
                    <path d="M12 18h.01"></path>
                  </g>
                </svg>
              </div>
              <div className="stat-number">
                <span>24/7</span>
              </div>
              <div className="stat-label">
                <span>Rush Availability</span>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="stat-number">
                <span>Instant</span>
              </div>
              <div className="stat-label">
                <span>Status Notifications</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="schedler-serve-ux">
(function(){
  // Simple scroll reveal effect for cards and stat items
  const revealOnScroll = () => {
    const elements = document.querySelectorAll(".service-card, .stat-item, .contact-card-wrapper")
    const triggerBottom = window.innerHeight * 0.85

    elements.forEach((el) => {
      const elTop = el.getBoundingClientRect().top
      if (elTop < triggerBottom) {
        el.style.opacity = "1"
        el.style.transform = "translateY(0)"
      }
    })
  }

  // Initialize styles for animation
  document.querySelectorAll(".service-card, .stat-item").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "all 0.6s ease-out"
  })

  window.addEventListener("scroll", revealOnScroll)
  revealOnScroll() // Initial check

  // Handle horizontal scroll snap for service rail on touch devices
  const rail = document.querySelector(".services-rail")
  if (rail) {
    let isDown = false
    let startX
    let scrollLeft

    rail.addEventListener("mousedown", (e) => {
      isDown = true
      startX = e.pageX - rail.offsetLeft
      scrollLeft = rail.scrollLeft
    })

    rail.addEventListener("mouseleave", () => {
      isDown = false
    })

    rail.addEventListener("mouseup", () => {
      isDown = false
    })

    rail.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - rail.offsetLeft
      const walk = (x - startX) * 2
      rail.scrollLeft = scrollLeft - walk
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer footerId="Footer"></Footer>
      <a href="https://play.teleporthq.io/signup">
        <div aria-label="Sign up to TeleportHQ" className="home-container4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="home-icon30"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="home-text43">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default Home
